import Utils from '../../modules/utils'

const saveNote = (vpoId, text, stage, filename, callbackFunc) => {
  const url = 'vpo_notes'
  const data = {vpoId, text, stage, filename}
  Utils.post(url, data, callbackFunc)
}

const saveNoteBulk = (vpoId, text, stage, filename, callbackFunc) => {
  const url = 'vpo_notes_bulk'
  const data = {vpoId, text, stage, filename}
  Utils.post(url, data, callbackFunc)
}

export {saveNote, saveNoteBulk}
